module.exports = __webpack_public_path__ + "img/Menu-15.11a8ff78.webp";